<template>
<v-card tile width="auto">
  <v-card-text class="my-2">
      <v-form ref="form">
        <v-row dense>
          <v-col v-for="(field, i) in form.status_finish.formulario.fields" :key="i"
                :cols="field.cols" :offset="field.offset" :hidden="field.hidden">

            <v-text-field v-if="field.field == 'text' && !field.hidden"
              v-model="model[field.nameid]"
              :label="field.name"
              :type="field.type"
              :rules="(field.rules)? fieldRequired : []"
              outlined
              dense>
            </v-text-field>

            <v-textarea v-else-if="field.field == 'textArea' && !field.hidden"
              v-model="model[field.nameid]"
              :label="field.name"
              :name="field.dimens"
              :rules="(field.rules)? fieldRequired : []"
              outlined
              dense>
            </v-textarea>

            <v-select v-else-if="field.field == 'select' && !field.hidden"
              v-model="model[field.nameid]"
              :label="field.name"
              :items="field.items"
              :rules="(field.rules)? fieldRequired : []"
              outlined
              dense>
            </v-select>

            <div v-else-if="field.field == 'radioButton' && !field.hidden">
              <label class="black--text font-weight-bold font-weight-black subtitle-2">{{field.name}}</label>
              <v-radio-group v-model="model[field.nameid]" :row="field.row"
                :rules="(field.rules)? fieldRequired : []" class="pa-0 ma-0"
                @change="RadioButtonEvent(field)">
                <v-radio v-for="(value,index) in field.items" :key="index"
                  :label="(value.name)? value.name : value"
                  :value="(value.name)? value.value : value">
                </v-radio>
              </v-radio-group>
            </div>

            <div v-else-if="field.field == 'checkbox'">
              <p class="ma-0 pa-0 text--black font-weight-bold font-weight-black subtitle-2">{{field.name}}</p>
                <v-checkbox v-for="value in field.items" :key="value" :class="(field.row)? 'mr-3 pa-0 checkbook-horizontal' : 'ma-0 pa-0'"
                  v-model="model[field.nameid]"
                  :label="value"
                  :value="value"
                  :rules="(field.rules)? fieldRequired : []">
                </v-checkbox>
            </div>

            <SearchDinamicField v-else-if="field.field == 'searchDataServer' && !field.hidden"
              :setterModel="model"
              :itemAction="field"
              :on-success="actionFieldData"/>

            <DatePicker v-else-if="field.field == 'textDatePicker' && !field.hidden"
              :setterModel="model[field.nameid]"
              :itemAction="field"
              :on-success="actionFieldData"/>

            <SelectedDinamicField v-else-if="field.field == 'selectDataServer' && !field.hidden"
              :setterModel="model[field.nameid]"
              :itemAction="field"
              :on-success="actionFieldData"/>

            <SelectedMultipleDinamicField v-else-if="field.field == 'selectMultipleDataServer' && !field.hidden"
                  :itemAction="field" :on-success="actionFieldData"/>

            <SelectedGroupDinamicField v-else-if="field.field == 'selectGroupDataServer' && !field.hidden"
                  :itemAction="field" :on-success="actionFieldData"/>

            <SearchDinamicFolioField v-else-if="field.field == 'searchDataFolioServer' && !field.hidden"
                  :itemAction="field" :on-success="actionFieldData"/>
          </v-col>

        </v-row>
      </v-form>
  </v-card-text>

  <v-card-actions>
    <v-layout justify-end>
      <v-btn class="mr-3" color="red darken-1" depressed outlined @click="onCancel">Cerrar</v-btn>
      <v-btn class="mr-3" color="success darken-1" depressed outlined @click="sendForm">{{form.status_finish.nombre}}</v-btn>
    </v-layout>
  </v-card-actions>
</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { Validate } from '@/mixins/validateFormMixin'
import DatePicker from '@/components/fields/DatePicker'
import SearchDinamicField from '@/components/fields/SearchDinamicField'
import SelectedDinamicField from '@/components/fields/SelectedDinamicField'
import SelectedGroupDinamicField from '@/components/fields/SelectedGroupDinamicField'
import SelectedMultipleDinamicField from '@/components/fields/SelectedMultipleDinamicField'
import SearchDinamicFolioField from '@/components/fields/SearchDinamicFolioField'
export default {
  name: 'MainProcessForm',
  props: ['form', 'model', 'onSuccess', 'onCancel'],
  mixins: [Validate],
  data: () => ({
    selected: []
  }),
  components: {
    DatePicker,
    SearchDinamicField,
    SelectedDinamicField,
    SelectedGroupDinamicField,
    SelectedMultipleDinamicField,
    SearchDinamicFolioField
  },
  methods: {
    ...mapActions([]),
    RadioButtonEvent (item) {
      if (item.action) {
        this[item.action](item)
      }
    },
    ShowFieldDinamic (field) {
      const response = this.model[field.nameid]
      if (field.isHidden) {
        field.isHidden.map((item, i) => {
          this.form.status_finish.formulario.fields.map((form, index) => {
            if (item === form.nameid) {
              if (response === 'NO') {
                form.hidden = false
                this.model[form.nameid] = ''
                return
              }
              form.hidden = true
              this.model[form.nameid] = null
            }
          })
        })
      }
    },

    checkboxEvent (item) {},

    actionFieldData (obj) {
      if (obj.field && obj.field.field === 'searchDataFolioServer') {
        this.model[obj.id] = obj.data.serie
        this.model.folio_timbrado = obj.data.folio
        this.actionDinamicData(obj.field)
        return
      }
      this.model[obj.id] = (obj.data === undefined) ? null : obj.data
      this.actionDinamicData(obj)
    },
    actionDinamicData (obj) {
      if (obj.action) {
        this[obj.action](obj)
      }
    },

    findBillEmployee ({ id, data, field }) {
      if (field.isHidden) {
        field.isHidden.map((item, i) => {
          this.form.status_finish.formulario.fields.map((form, index) => {
            if (item === form.nameid) {
              if (form.hidden) {
                form.params[id] = data
                form.hidden = false
                return
              }
              form.params = {}
              form.hidden = true
              this.model[form.nameid] = null
            }
          })
        })
      }
    },
    ShowFieldDinamicGral (field) {
      if (field.isHidden) {
        field.isHidden.map((item, i) => {
          this.form.status_finish.formulario.fields.map((form) => {
            if (item === form.nameid) {
              console.log('form', form)
              if (form.hidden) {
                form.hidden = false
                return
              }
              form.hidden = true
              this.model[form.nameid] = null
            }
          })
        })
      }
    },

    sendForm () {
      if (this.$refs.form.validate()) {
        const item = this.validateComponents()
        if (item !== null) {
          this.$swal({
            type: 'error',
            icon: 'error',
            title: 'Advertencia!',
            text: ' Campo ' + item.name + ' no debe ser vacio!!'
          })
          return
        }
        this.onSuccess({
          descripcion: this.model,
          action: this.form.accion,
          status: this.form.estatus_final_id,
          actual: this.form.estatus_actual_id
        })
      }
    },
    validateComponents () {
      let itemSelected = null
      this.form.status_finish.formulario.fields.map(item => {
        if (item.rules) {
          if (!item.hidden) {
            if (!this.model[item.nameid]) {
              itemSelected = item
            } else if (this.model[item.nameid] === null) {
              itemSelected = item
            }
          }
        }
      })
      return itemSelected
    }
  },
  computed: {
    ...mapGetters([])
  }
}
</script>

<style>
.box-color-red {
  border: 1px red solid;
}
div .checkbook-horizontal{
  display: inline-block;
}
</style>
